"use strict";
/**
 * customMonitor Module
 *
 * Description 人员同步
 * Author:fanglijuan 2017-5-25
 */
angular.module('accountSynchroToPersonalModule', ['accountSynchroToPersonalServiceModule']).
controller('accountSynchroToPersonalController', ['$scope', '$timeout', '$filter', '$q', '$state', '$stateParams', '$location', 'treeService', 'trsHttpService', 'modalDialog', 'trsspliceString', 'localStorageService', 'accountSynchroToPersonalService',
    function($scope, $timeout, $filter, $q, $state, $stateParams, $location, treeService, trsHttpService, modalDialog, trsspliceString, localStorageService, accountSynchroToPersonalService) {
        initStatus();
        initData();
        /**
         * [initStatus description]初始化状态
         */
        function initStatus() {
            $scope.status = {
                synchroStatus: [{
                    name: "全部",
                    value: 5,
                }, {
                    name: "已同步",
                    value: 2
                }, {
                    name: "未同步",
                    value: 1
                }],
            };
            $scope.data = {
                keywords: "",
                list: [],
                copyCurrPage: 1,
                totalCounts: 0,
            };
            $scope.page = {
                "CURRPAGE": 1,
                "PAGESIZE": 20,
                "ITEMCOUNT": 0,
            };
        }
        /**
         * [initData description]
         * @return {[type]} [description]
         */
        function initData() {
            initDropDown();
            requestData();
        }
        /**
         * [initDropDown description]初始化下拉框
         * @return {[type]} [description]
         */
        function initDropDown() {
            $scope.status.selectedSynchroStatus = angular.copy($scope.status.synchroStatus[2]);
        }
        //下一页
        $scope.pageChanged = function() {
            $scope.data.copyCurrPage = $scope.page.CURRPAGE;
            requestData();
        };

        //跳转指定页面
        $scope.jumpToPage = function() {
            if ($scope.data.copyCurrPage > $scope.page.PAGECOUNT) {
                $scope.data.copyCurrPage = $scope.page.PAGECOUNT;
            }
            $scope.page.CURRPAGE = $scope.data.copyCurrPage;
            requestData();
        };
        /**
         * [selectPageNum description]单页选择分页数
         * @return {[type]} [description]
         */
        $scope.selectPageNum = function() {
            $scope.data.copyCurrPage = 1;
            requestData();
        };
        /**
         * [requestData description:数据请求方法]
         */
        function requestData() {
            var params = {
                serviceid: "mlf_usermanagement",
                methodname: "queryAllSynUsers",
                CurrPage: $scope.page.CURRPAGE,
                pagesize: $scope.page.PAGESIZE,
                SynUserName: $scope.data.keywords,
                //OpType: $scope.status.selectedSynchroStatus.value,
            };
            if ($scope.status.selectedSynchroStatus.value != 5) { //选择下拉框全部的时候不传OpType
                params.SynStatus = $scope.status.selectedSynchroStatus.value;
            }
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                $scope.data.list = data.DATA;
                $scope.page = data.PAGER
            });
        }
        /**
            将日期字符串转换为时间戳
            **/
        $scope.timeStamp = function(item) {
            var time = "";
            if (item.CREATETIME != "") {
                var date = new Date(Date.parse(item.CREATETIME));
                time = $filter("date")(date, "yyyy-MM-dd HH:mm").toString();
            }
            return time;
        };
        /**
         * [checkOpType description]显示类型
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        /*$scope.checkOpType = function(item) {
            if (item.OPTYPE == 1) {
                item.OpTypeToChanese = '新增';
            } else if (item.OPTYPE == 2) {
                item.OpTypeToChanese = '修订';
            } else if (item.OPTYPE == 3) {
                item.OpTypeToChanese = '删除';
            }
            return item.OpTypeToChanese;
        };*/
        /**
         * [queryDropDown description]根据下拉框查询
         * @return {[type]} [description]null
         */
        $scope.queryDropDown = function() {
            requestData();
        };
        /**
         * [userNameSearch description;检索:(全文检索)]
         * @param  {[type]} ev [description:按下空格也能提交]
         */
        $scope.groupNameSearch = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                requestData();
            }
        };

        /**
         * [doOperation description]新增、删除、修改、调动等操作
         * @return {[type]} [description]
         */
        $scope.doOperation = function(item) {
            //item.OPTYPE = 3;//指定OPTYPE，测试删除的弹窗
            if (item.OPTYPE == '新增用户' || item.OPTYPE == '修改用户') { //新增or修订
                accountSynchroToPersonalService.addSynchroToPersonal(item, "userInfo").then(function(data) {
                    requestData();
                }, function(data) {
                    //失败
                });
            } else if (item.OPTYPE == '删除用户') { //删除
                accountSynchroToPersonalService.deleteSynchroToPersonal(item, "userInfo").then(function(data) {
                    requestData();
                }, function(data) {
                    //失败
                });
            } else if (item.OPTYPE == '调动用户') { //调动
                accountSynchroToPersonalService.transferSynchroToPersonal(item, "userInfo").then(function(data) {
                    requestData();
                }, function(data) {
                    //失败
                });
            }
        };
    }
]);
